import React from 'react';
import { Modal } from 'react-bootstrap';
import UnlockFeatureForm from '../forms/Subscription/Unlock_Features';

function UnlockFeatures(props) {
  const { service } = props;
  
  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal-width"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="d-flex align-items-center">
              {service?.icon && <service.icon size={24} className="mr-2" style={{ color: service.color }} />}
              <h5 className="text-grey mb-0">Unlock Feature</h5>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UnlockFeatureForm {...props} service={service} />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default UnlockFeatures;